import { createSlice } from "@reduxjs/toolkit";
import { getAllAlarmCauses, createAlarmCause, updateAlarmCause, deleteAlarmCause, getAlarmCauseById, } from "../thunk/alarm-causes-thunk";
const initialState = {
    alarmCauses: null,
    selectedAlarmCause: null,
    paginationInfo: null,
    loading: false,
    error: null,
    createLoading: false,
    updateLoading: false,
    deleteLoading: false,
    singleLoading: false,
    currentPageNumber: 1,
    currentPageSize: 25,
    sortColumn: null,
    sortDirection: null,
    filters: {},
};
const alarmCausesSlice = createSlice({
    name: "alarmCauses",
    initialState,
    reducers: {
        setSelectedAlarmCause: (state, action) => {
            state.selectedAlarmCause = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
        setFilters: (state, action) => {
            state.filters = Object.assign(Object.assign({}, state.filters), action.payload);
            state.currentPageNumber = 1;
        },
        setGlobalSearch: (state, action) => {
            state.filters.globalSearch = action.payload;
            state.currentPageNumber = 1;
        },
        setPagination: (state, action) => {
            state.currentPageNumber = action.payload.pageNumber;
            state.currentPageSize = action.payload.pageSize;
        },
        setPageNumber: (state, action) => {
            state.currentPageNumber = action.payload;
        },
        setPageSize: (state, action) => {
            state.currentPageSize = action.payload;
        },
        setSorting: (state, action) => {
            state.sortColumn = action.payload.sortColumn;
            state.sortDirection = action.payload.sortDirection;
        },
        resetFiltersAndPagination: (state) => {
            state.filters = {};
            state.currentPageNumber = 1;
            state.currentPageSize = 25;
            state.sortColumn = null;
            state.sortDirection = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllAlarmCauses.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(getAllAlarmCauses.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload) {
                state.alarmCauses = action.payload.items;
                state.paginationInfo = {
                    totalCount: action.payload.totalCount,
                    pageNumber: action.payload.pageNumber,
                    pageSize: action.payload.pageSize,
                    totalPages: action.payload.totalPages,
                    hasPreviousPage: action.payload.hasPreviousPage,
                    hasNextPage: action.payload.hasNextPage,
                };
            }
        })
            .addCase(getAllAlarmCauses.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
            .addCase(getAlarmCauseById.pending, (state) => {
            state.singleLoading = true;
            state.error = null;
        })
            .addCase(getAlarmCauseById.fulfilled, (state, action) => {
            state.singleLoading = false;
            state.selectedAlarmCause = action.payload;
        })
            .addCase(getAlarmCauseById.rejected, (state, action) => {
            state.singleLoading = false;
            state.error = action.payload;
        })
            .addCase(createAlarmCause.pending, (state) => {
            state.createLoading = true;
            state.error = null;
        })
            .addCase(createAlarmCause.fulfilled, (state, action) => {
            state.createLoading = false;
            if (state.alarmCauses && state.currentPageNumber === 1) {
                state.alarmCauses.unshift(action.payload);
                if (state.paginationInfo) {
                    state.paginationInfo.totalCount += 1;
                }
            }
        })
            .addCase(createAlarmCause.rejected, (state, action) => {
            state.createLoading = false;
            state.error = action.payload;
        })
            .addCase(updateAlarmCause.pending, (state) => {
            state.updateLoading = true;
            state.error = null;
        })
            .addCase(updateAlarmCause.fulfilled, (state, action) => {
            var _a;
            state.updateLoading = false;
            if (state.alarmCauses) {
                const index = state.alarmCauses.findIndex((ac) => ac.id === action.payload.id);
                if (index !== -1) {
                    state.alarmCauses[index] = action.payload;
                }
            }
            if (((_a = state.selectedAlarmCause) === null || _a === void 0 ? void 0 : _a.id) === action.payload.id) {
                state.selectedAlarmCause = action.payload;
            }
        })
            .addCase(updateAlarmCause.rejected, (state, action) => {
            state.updateLoading = false;
            state.error = action.payload;
        })
            .addCase(deleteAlarmCause.pending, (state) => {
            state.deleteLoading = true;
            state.error = null;
        })
            .addCase(deleteAlarmCause.fulfilled, (state, action) => {
            var _a;
            state.deleteLoading = false;
            if (state.alarmCauses) {
                state.alarmCauses = state.alarmCauses.filter((ac) => ac.id !== action.payload);
                if (state.paginationInfo) {
                    state.paginationInfo.totalCount -= 1;
                }
            }
            if (((_a = state.selectedAlarmCause) === null || _a === void 0 ? void 0 : _a.id) === action.payload) {
                state.selectedAlarmCause = null;
            }
        })
            .addCase(deleteAlarmCause.rejected, (state, action) => {
            state.deleteLoading = false;
            state.error = action.payload;
        });
    },
});
export const { setSelectedAlarmCause, clearError, setFilters, setGlobalSearch, setPagination, setPageNumber, setPageSize, setSorting, resetFiltersAndPagination, } = alarmCausesSlice.actions;
export default alarmCausesSlice.reducer;
